import React, { useContext } from 'react';
import { AirDropContext } from '../../../utils/AirDropProvider';
import Logo from '../../atoms/Logo/Logo';
import LangPicker from '../../atoms/LangPicker/LangPicker';
import './Navbar.scss';

function Navbar() {
  const config : any = useContext(AirDropContext);
  return (
    <header>
      <div className="nav__wrapper">
        <Logo />
        {config?.languagePicker?.show && (
          <LangPicker />
        )}
      </div>
    </header>
  );
}

export default Navbar;
